import React from 'react';
import { LoadingSpinner } from '@/components/loading';
import { DOWNLOAD_FILE_LIST_API_URL } from '@/constants/apiUrls';
import { image } from '@/theme';
import {
  UploadFilesInvalidText,
  UploadFilesLimitRequiredText,
  UploadFilesSizeLimitText,
  UploadFilesText,
} from '@/lib/react-intl/TranslatedTexts';
import styled from '@emotion/styled';
import { RiCloseLine } from '@remixicon/react';
import { Alert } from '@mui/material';

const List = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem 0',
  margin: '1rem 0 2rem',
  padding: '1rem 0',
}));

const Item = styled.div(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '0 1rem',
}));

const FileName = styled.a(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '2rem',
  borderBottom: `1px solid ${theme.color.grey03}`,
  width: 'fit-content',
  cursor: 'pointer',
}));

const CloseIcon = styled(RiCloseLine)(({ theme }) => ({
  cursor: 'pointer',
  transition: 'all 0.3s',
  color: theme.color.grey02,

  '&:hover': {
    color: theme.color.red01,
  },
}));

const StyledAlert = styled(Alert)(() => ({
  margin: '1rem 0',
}));

const Label = styled.label(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  background: theme.color.point04,
  gap: '0 1rem',
  cursor: 'pointer',
  padding: '1rem',
  borderRadius: '1rem',
  color: theme.color.base_white,
  fontSize: '1.4rem',
  margin: '1rem 0',
}));
const FileUploadInput = ({
  loading,
  fileList,
  maxFileLengthAlert,
  fileInvalidAlert,
  maxFileSizeAlert,
  deleteFileFromList,
  type,
}) => {
  return (
    <>
      {loading[type] ? (
        <LoadingSpinner isFetching width="3.2rem" />
      ) : fileList?.[type]?.length > 0 ? (
        <List>
          {fileList?.[type]?.map((file) => {
            return (
              <Item key={file.file_url}>
                <FileName
                  href={`${DOWNLOAD_FILE_LIST_API_URL}?path=${file.file_path}&tname=${file.temp_file_name}&name=${file.origin_file_name}`}
                >
                  {file.origin_file_name}
                </FileName>

                <CloseIcon size={24} onClick={() => deleteFileFromList(file, type)} />
              </Item>
            );
          })}
        </List>
      ) : (
        <Label htmlFor={`images-${type}`}>
          <img src={image.fileUploadIcon.default} alt="" width={20} />

          <div>
            <UploadFilesText />
          </div>
        </Label>
      )}

      {maxFileLengthAlert[type] && (
        <StyledAlert severity="warning">
          <UploadFilesLimitRequiredText />
        </StyledAlert>
      )}

      {fileInvalidAlert[type] && (
        <StyledAlert severity="warning">
          <UploadFilesInvalidText />
        </StyledAlert>
      )}

      {maxFileSizeAlert[type] && (
        <StyledAlert severity="warning">
          <UploadFilesSizeLimitText />
        </StyledAlert>
      )}
    </>
  );
};

export default FileUploadInput;
